import { createContext, useContext, useEffect, useState } from 'react';
import { Marketing } from '~/types/domain.ts';
import { useQuery } from '~/utils/router.ts';

const MarketingContext = createContext<Marketing>({});

export function MarketingProvider({ children }: { children: React.ReactNode }) {
    const query = useQuery();
    const [params, setParams] = useState<Marketing>({});

    useEffect(() => {
        const source = params.utm_source || query.get('utm_source') || '';
        const medium = params.utm_medium || query.get('utm_medium') || '';
        const campaign = params.utm_campaign || query.get('utm_campaign') || '';
        const position = params.utm_position || query.get('utm_position') || '';
        setParams({
            utm_source: source,
            utm_medium: medium,
            utm_campaign: campaign,
            utm_position: position,
        });
    }, [query]);

    return <MarketingContext.Provider value={params}>{children}</MarketingContext.Provider>;
}

export function useMarketingData(): Marketing {
    return useContext(MarketingContext);
}
